export default __webpack_public_path__ + "static/media/regreenbus_info_con_03.5a4530ac.png";